import CookieManager from "@react-native-cookies/cookies";
import { GetUserResponse, LoginResponse } from "../AuthDataTypes";
import { usePersistBoundStore } from "../zustand/Store";
import { useCallback } from "react";

const TYPO3_LOGIN_URL = 'https://staging.boyens-api.de/api/auth';
const TYPO3_LOGOUT_URL = 'https://staging.boyens-api.de/api/auth/logout';
const TYPO3_GETUSER_URL = 'https://staging.boyens-api.de/api/user';
const updateSessionToken = usePersistBoundStore.getState().updateSessionToken;


export async function isLoggedIn(): Promise<boolean> {
    const token = usePersistBoundStore.getState().token;
    
    let isLoggedIn = false;
    
    const getUserResponse: GetUserResponse = await getUser(token);
    if (getUserResponse.uid) {
        isLoggedIn = true;
    }
    
    return isLoggedIn
}

export async function authUser(username: string, password: string): Promise<LoginResponse> {
    const body = JSON.stringify({
        username,
        password,
    });
    const result = await fetch(TYPO3_LOGIN_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: body,
    });

    const setCookieHeader = result.headers.get('Set-Cookie');
    if (setCookieHeader) {
        const feTypoUserMatch = setCookieHeader.match(/fe_typo_user=([^;]+);/);
        if (feTypoUserMatch) {
            const feTypoUserValue = feTypoUserMatch[1];
            
            updateSessionToken(feTypoUserValue);
        } else {
            console.warn("fe_typo_user token not found in Set-Cookie header.");
        }
    } else {
        console.warn("No Set-Cookie header found in the response.");
    }
    const response: LoginResponse = await result.json();
    updateSessionToken(response.token);
    
    return response;
};

export async function logoutUser() {
    const result = await fetch(TYPO3_LOGOUT_URL, {
        method: 'GET',
    });
    updateSessionToken(null);
}

export async function getUser(token: string | null): Promise<GetUserResponse> {
    let response = null;
    try {
        const result = await fetch(TYPO3_GETUSER_URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!result.ok) {
            console.error(`HTTP error! status: ${result.status}`);
            throw new Error('Failed to fetch');
        }
        
        const response = await result.json();
        
        return response;
    } catch (error) {
        console.error("Fetch error:", error);
        throw error;
    }
}